import React, { useState } from 'react';
import Faculty from '../components/Programs/Faculty';
import Aside from '../modules/SideNav/Aside';

function FacultyLayout() {
    const rtl = false;

    const [toggled, setToggled] = useState(false);

    const handleToggleSidebar = value => {
        setToggled(value);
    };

    return (
        <div className={`app ${rtl ? 'rtl' : ''} ${toggled ? 'toggled' : ''}`}>
            <Aside
                rtl={rtl}
                toggled={toggled}
                handleToggleSidebar={handleToggleSidebar}
            />
            <Faculty handleToggleSidebar={handleToggleSidebar} />
        </div>
    );
}

export default FacultyLayout;
